import { rem } from 'polished'
import styled from 'styled-components'

interface IChecklistPopoverStyledProps {}

export const ChecklistPopoverStyled = styled.div<IChecklistPopoverStyledProps>`
  font-size: ${rem(16)};
`
